import React, { useState, useEffect, useReducer } from 'react'
import { Col, Panel, Row, IconButton, Icon, ButtonGroup, Message } from 'rsuite'
import { useForm, Controller } from 'react-hook-form'
import { useHistory } from 'react-router-dom'
import ViewFileseFillingTable from './ViewFileseFillingTable'

export default function ViewFileseFillingWidget(props) {
  const { showCommandButton, isEdit, onChangeIsEdit, dataList, taxType } = props
  const { register, handleSubmit, errors, control, getValues, setValue, setError, clearErrors } =
    useForm()
  const [isLoading, setIsLoading] = useState(false)
  const [formSchema, setFormSchema] = useState(props.schema)
  const [isExpanded, setIsExpanded] = useState(true)
  const [_, forceUpdate] = useReducer((x) => x + 1, 0)
  // console.log('dataList==>', dataList)
  return (
    <>
      <Panel
        shaded
        collapsible
        defaultExpanded
        bordered
        header={''}
        expanded={isExpanded}
        onSelect={() => {
          setIsExpanded(!isExpanded)
          setTimeout(() => {
            forceUpdate()
          }, 100)
        }}
        style={{ marginTop: 10 }}
      >
        <ViewFileseFillingTable
          schema={formSchema}
          data={dataList}
          loading={isLoading}
          taxType={taxType}
        />
      </Panel>
    </>
  )
}
